import { graphql } from 'relay-runtime';

export const userHiddenClasses = graphql`
  query ClassCategoriesUserHiddenClassesQuery($publicUserId: String!, $skip: Boolean = false) {
    userByPublicUserId(publicUserId: $publicUserId) @skip(if: $skip) {
      userClassCategories {
        classId
        category
        value
      }
    }
  }
`;

export const setClassCategory = graphql`
  mutation ClassCategoriesSetClassCategoryMutation($input: SetClassCategoryInput!) {
    setClassCategory(input: $input) {
      userClassCategoryNode {
        id
        classId
        category
        value
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const hideClass = graphql`
  mutation ClassCategoriesHideClassMutation($input: HideClassInput!) {
    hideClass(input: $input) {
      userClassCategoryNode {
        id
        classId
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const showClass = graphql`
  mutation ClassCategoriesShowClassMutation($input: ShowClassInput!) {
    showClass(input: $input) {
      operationStatus {
        isSuccessful
        errors
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;
